<template>
    <div class="home">
		<router-view v-if="$route.name == 'login'" />
		<router-view v-if="$route.name == 'public_claims'" />
		<div v-show="$route.name !== 'login' && $route.name !== 'public_claims'" class="grid">
			<navigation-view class="home__navigation" :items="pages" @itemClick="navItemClick" />
			<div class="home__top-bar" :style="dev ? 'grid-template-columns: auto fit-content(200px) fit-content(200px) 50px 50px 50px 50px 50px 10px;' : 'grid-template-columns: auto fit-content(200px) fit-content(200px) 50px 50px 10px;'">
				<search-bar-view ref="search" class="home__top-bar__search-bar" placeholder="Søg efter noget du skal bruge..." @keyup="searchKeyUp($event)" v-model="search" />
				<image-button-view class="home__top-bar__image-button" :label="$store.state.department.label" image="/images/icon-department.png" @click.stop="departmentButtonClick($event)" />
				<image-button-view class="home__top-bar__image-button" :label="$store.state.employee.name" :image="$store.state.employee._links.photo_48x48.href" @click.stop="userButtonClick($event)" />
				<icon-button-view v-if="dev" class="home__top-bar__icon-button" icon="bell" />
				<icon-button-view v-if="dev" class="home__top-bar__icon-button" icon="bulb" />
				<icon-button-view v-if="dev" class="home__top-bar__icon-button" icon="message_warning" @click="annotate = true" />
				<icon-button-view class="home__top-bar__icon-button" icon="clip" :badge="$store.state.attachments.length" @click.stop="attachmentsButtonClick($event)" />
				<icon-button-view ref="quickCreateButton" class="home__top-bar__icon-button" icon="plus" @click.stop="quickCreateButtonClick($event)" />
			</div>
			<div class="home__content">
				<fade-transition>
					<router-view ref="page" class="home__page" v-on="{push, pop, replace, close}" />
				</fade-transition>
				<window-stack ref="windowStack" class="home__content__window-stack" />
			</div>
		</div>
		<popup-controller style="z-index: 100000;" :page="page" ref="popupController" @goto="goto(...arguments)" @enter="enter" @leave="leave" @changeTab="(tab) => { this.tab = tab; }" />
		<div :class="{
			'mobile-menu': true,
			open: mobile.menu.open
		}">
			<mobile-navigation-view class="navigation" :items="pages" @itemClick="navItemClick" />
		</div>
		<annotation-view v-if="annotate" @close="annotate = false" />
    </div>
</template>

<script>
	import WindowStack from '../WindowStack'
	import PopupController from '../PopupController'
	import ContextPopupView from '../views/ContextPopupView'

	import IconButtonView from '../views/IconButtonView'
	
	import FadeTransition from '../../transitions/SlideTransition'

	import Settings from '../windows/SettingsWindow'

	import ProfilePicture from '@/assets/images/profile-picture.png'

	import merge from '../functions/merge'



	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'

	import LeadModel from '../model/Lead'
	import LeadWindow from '../windows/LeadWindow'

	import QuoteModel from '../model/Quote'
	import QuoteWindow from '../windows/QuoteWindow'

	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'

	import ReservationModel from '../model/Reservation'
	import ReservationWindow from '../windows/ReservationWindow'	

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import TaskModel from '../model/Task'
	import TaskWindow from '../windows/TaskWindow'

	import CourierTaskModel from '../model/CourierTask'
	import CourierTaskWindow from '../windows/CourierTaskWindow'



	import SearchPopupView from '../views/SearchPopupView'

	import MailWindow from '../windows/MailWindow'


	import { bus } from '../../bus'


    export default {
        components: {
			windowStack: WindowStack,
			fadeTransition: FadeTransition,
			popupController: PopupController
		},
		data() {
			return {
				tab: null,
				abortSearch: null,
				profilePicture: ProfilePicture,
				taskTypes: [],
				direction: 'down',
				dev: true,
				search: '',
				searchTimeout: null,
				page: 1,
				mobile: {
					menu: {
						open: false
					}
				},
				annotate: false,
			};
		},
		computed: {
			_taskTypes() {
				var r = {};

				for (var i = 0; i < this.taskTypes.length; ++i) {
					r[this.taskTypes[i].name] = this.taskTypes[i];
				}

				return r;
			},
			_actions() {
				var self = this;

				var actions = [
					{
						label: 'Kontakt',
						action: function () {
							self.$store.state.windowStack.push(ContactWindow, {
								value: ContactModel.entity(),
								async submit(entity) {
									if (await ContactModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					null,
					{
						label: 'Henvendelse',
						action: function () {
							var ent = LeadModel.entity();
							ent.department_id 		= self.$store.state.employee.department_id;
							ent.employee_id 		= self.$store.state.employee.id;
							ent._embedded.employee 	= self.$store.state.employee;

							self.$store.state.windowStack.push(LeadWindow, {
								value: ent,
								submit: async function (entity) {
									if (await LeadModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'Tilbud',
						action: function () {
							var ent 				= QuoteModel.entity();
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(QuoteWindow, {
								value: ent,
								async submit(entity) {
									if (await QuoteModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'Ordre',
						action: function () {
							var ent 				= OrderModel.entity();
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(OrderWindow, {
								value: ent,
								async submit(entity, invoice = false, paid = false) {
									if (await OrderModel.save(self.axios, entity, invoice, paid)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					null,
					{
						label: 'Reservation',
						action: function () {
							var ent 				= ReservationModel.entity();
							ent.department_id 		= self.$store.state.employee.department_id;

							self.$store.state.windowStack.push(ReservationWindow, {
								value: ent,
								async submit(entity) {
									if (await ReservationModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					null,
					/*{
						label: 'Flytning',
						action: function () {
							var ent 				= MoveTaskModel.entity();
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(MoveTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await MoveTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},*/
					{
						label: 'Besigtigelse',
						action: function () {
							var ent 				= SurveyTaskModel.entity();
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(SurveyTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await SurveyTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					/*{
						label: 'Levering',
						action: function () {
							var ent 				= CourierTaskModel.entity();
							ent.type				= 'delivery';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(CourierTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await CourierTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},*/
					{
						label: 'Afhentning',
						action: function () {
							var ent 				= CourierTaskModel.entity();
							ent.type				= 'pickup';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(CourierTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await CourierTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'Møde',
						action: function () {
							var ent 				= TaskModel.entity();
							ent.type				= 'conf';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(TaskWindow, {
								value: ent,
								async submit(entity) {
									if (await TaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'U/B kørsel',
						action: function () {
							var ent 				= TaskModel.entity();
							ent.type				= 'free';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(TaskWindow, {
								value: ent,
								async submit(entity) {
									if (await TaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'Handling',
						action: function () {
							var ent 				= TaskModel.entity();
							ent.type				= 'handling';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(TaskWindow, {
								value: ent,
								async submit(entity) {
									if (await TaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
					{
						label: 'Rengøring',
						action: function () {
							var ent 				= TaskModel.entity();
							ent.type				= 'cleaning';
							ent.employee_id 		= self.$store.state.employee.id;
							ent.department_id 		= self.$store.state.employee.department_id;
							ent._embedded.employee	= self.$store.state.employee;

							self.$store.state.windowStack.push(TaskWindow, {
								value: ent,
								async submit(entity) {
									if (await TaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('clear');
										bus.$emit('update');
									}
								}
							});
						}
					},
				];

				// Inject general tasks
				

				/*for (var i = 0; i < this.taskTypes.length; ++i) {
					if (this.taskTypes[i].super != 'general') continue;

					

					actions.push({
						label: self.taskTypes[i].label,
						action: function () {
							var j = i;

							return function () {
								var ent 				= TaskModel.entity();
								ent.type				= self.taskTypes[j].name;
								ent.employee_id 		= self.$store.state.employee.id;
								ent.department_id 		= self.$store.state.employee.department_id;
								ent._embedded.employee	= self.$store.state.employee;

								self.$store.state.windowStack.push(TaskWindow, {
									value: ent,
									async submit(entity) {
										if (await TaskModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											//self.update();
											bus.$emit('clear');
											bus.$emit('update');
										}
									}
								});
							};
						}()
					});
				}*/

				if (this.dev) {
					actions.push(null);
					actions.push({
						label: 'Opbevaring (dev)',
						action: function () {
							
						}
					});
					actions.push(null);
					actions.push({
						label: 'Skadessag (dev)',
						action: function () {
							
						}
					});
				}

				return actions;
			}
		},
		props: ['pages'],
		methods: {
			navItemClick: function (name) {
				if (name == 'settings') {
					this.$refs.windowStack.push(Settings);
				} else {
					this.$router.push({
						name: name
					});
				}

				this.mobile.menu.open = false;
			},
			push: function () {
				this.$refs.windowStack.push(Settings);
			},
			pop: function () {
				this.$refs.windowStack.pop();
			},
			replace: function () {
				this.$refs.windowStack.replace(IconButtonView);
			},
			close: function () {
				this.$refs.windowStack.close();
			},
			done: function () {
				
			},
			enter(task) {
				
			},
			leave() {
				
			},
			goto(page) {
				const self = this;
				this.$store.state.popupController.close();
				
				this.$nextTick(() => {
					self.doSearch(page);
				});
			},
			doSearch(page) {
				this.$store.state.popupController.close();

				// Cancel previous search
				if (this.abortSearch) {
					this.abortSearch.abort();
					this.abortSearch = null;
				}

				if (this.search == '') return;


				var self = this;

				if (page === undefined) {
					page = 1;
					this.page = 1;
				} else {
					self.$store.state.popupController.close();
					this.page = page;
				}

				if (this.SearchPopupView == '') return;

				this.abortSearch = new AbortController();

				const cutomers	= this.axios.get('/search/customers?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const invoices	= this.axios.get('/search/invoices?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const leads		= this.axios.get('/search/leads?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const orders	= this.axios.get('/search/orders?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const quotes	= this.axios.get('/search/quotes?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const suppliers	= this.axios.get('/search/suppliers?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });
				const tasks		= this.axios.get('/search/tasks?search=' + encodeURI(this.search) + '&page=' + page, { signal: this.abortSearch.signal });

				self.$store.state.popupController.popup(SearchPopupView, {
					anchor: self.$refs.search.$el,
					align: 'left',
					left: 50,
					results: null,
					gotoTab: self.tab,
					request: [
						cutomers,
						invoices,
						leads,
						orders,
						quotes,
						suppliers,
						tasks
					],
					page: page,
					select: function (type, id) {
						
					}
				});

				//this.search = '';
			},
			searchKeyUp(e) {
				/*if (e.keyCode == 13) {
					this.doSearch();
				}

				this.$store.state.popupController.close();
				return;*/

				
				var self = this;

				if (this.searchTimeout) clearTimeout(this.searchTimeout);

				self.$store.state.popupController.close();

				this.searchTimeout = setTimeout(function () {
					self.doSearch();
				}, 500);
			},
			userButtonClick(event) {
				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: [
						{
							label: 'Log ud',
							action: function () {
								
								self.$store.commit('auth', null);
								localStorage.removeItem('auth');
								self.$router.push({
									name: 'login'
								});
							}
						}
					]
				});
			},
			async updateDepartment() {
				var self = this;

				return new Promise(function (resolve) {
					self.axios
						.get('/department/')
						.then(function (r) {
							self.$store.commit('department', r.data);
							bus.$emit('update');
							resolve(true);
						}, function () {
							resolve(false);
						});
				});
			},
			async setDepartment(departmentId) {
				var self = this;

				return new Promise(function (resolve) {
					self.axios
						self.axios
					.put('/token/', {
						department_id: departmentId
					})
					.then(async function (r) {
						self.$store.state.auth = r.data;
						await self.updateDepartment();

						resolve(true);
					}, function () {
						resolve(false);
					});
				});
			},
			async departmentButtonClick(event) {
				var self = this;
				var departments = this.$store.state.employee._embedded.departments
				var actions = [];

				if (departments.length == 0) return;

				for (var i = 0; i < departments.length; ++i) {
					actions.push(function () {
						var j = i;

						return {
							label: departments[j].label,
							async action() {
								bus.$emit('clear');
								await self.setDepartment(departments[j].id);
							}
						};
					}());
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: actions
				});
			},
			quickCreateButtonClick(event) {
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: this.$refs.quickCreateButton.$el,
					align: 'left',
					actions: this._actions
				});
			},
			attachmentsButtonClick(event) {
				

				if (this.$store.state.attachments.length == 0) return 0;

				var self = this;

				var actions = [];

				for (var i = 0; i < this.$store.state.attachments.length; ++i) {
					var a = this.$store.state.attachments[i];

					actions.push({
						label: a.label,
						action: function () {
							var idx = i;

							return function () {
								self.$store.state.attachments.splice(idx, 1);
							};
						}()
					});
				}

				actions.push(null);

				actions.push({
					label: 'Fjern alle',
					action() {
						self.$store.state.attachments = [];
					}
				});

				actions.push({
					label: 'Send filer',
					action() {
						self.$store.state.windowStack.push(MailWindow, {
							entity: {
								recipients: ''
							},
							async submit(entity) {
								self.$store.state.windowStack.pop();
								var count = (await self.axios.post('/messages/emails/', entity)).data;
								alert('Sendt til ' + count + ' modtagere');
							}
						});
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: actions
				});
			}
		},
		watch: {
			'$route.name': function (val, oldVal) {
				for (var i in this.pages) {
					if (this.pages[i].name == val) {
						this.direction = 'up';
						return;
					}

					if (this.pages[i].name == oldVal) {
						this.direction = 'down';
						return;
					}
				}
			}
		},
		mounted: function () {
			var self = this;
			

			

			

			this.$store.state.windowStack = this.$refs.windowStack;
			this.$store.state.popupController = this.$refs.popupController;

			

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.taskTypes = r.data._items;
					//self.departments = r.data._items;
				});

			

			this.dev = process.env.NODE_ENV == 'development';





		},
		created() {
			
			var self = this;

			window.addEventListener('keydown', function(e) {
				// F5
				if (e.keyCode == 116) {
					e.returnValue = false;
					//e.keyCode = 0;
					bus.$emit('update');
					return false;
				}
			});

			bus.$on('mobile-menu-toggle', function () {
				self.mobile.menu.open = !self.mobile.menu.open;
			});
		}
    }
</script>

<style lang="scss">
	.home {
		width: 100%;
		height: 100%;

		& > .mobile-menu {
			position: absolute;
			left: -300px;
			top: 0;
			width: 300px;
			height: 100%;
			transition: left 250ms ease-in-out;

			&.open {
				left: 0px;
			}

			& > .navigation {
				height: 100%;
			}
		}

		& > .grid {
			width: 100%;
			height: 100%;
			display: grid;
			grid-template-columns: 70px auto;
			grid-template-rows: 61px auto;
			grid-template-areas:
				"home__navigation home__top-bar"
				"home__navigation home__page";
		}

		&__navigation {
			grid-area: home__navigation;
		}

		&__top-bar {
			position: relative;
			grid-area: home__top-bar;
			background-color: white;
			/*border-bottom: 1px solid #cecece; */

			display: grid;
			grid-template-columns: auto 50px 50px 50px fit-content(200px);
			grid-template-rows: auto;

			&__image-button {
				height: 100%;
			}
		}

		&__content {
			grid-area: home__page;
			position: relative;
			overflow: hidden;
		}

		&__page {
			width: 100%;
			left: 0;
			top: 0;
			bottom: 0;

			position: absolute;
		}
	}

	.navigation {
		&__pos--default {
			margin-top: 20px;
		}

		&__pos--bottom {
			position: absolute;
			left: 0;
			bottom: 20px;
			width: 100%;
		}
	}

	@media only screen and (max-width: 600px) {
		.home {
			& > .grid {
				grid-template-columns: 1fr;
				grid-template-rows: 1fr;

				grid-template-areas: "home__page";
			}

			&__navigation, &__top-bar {
				display: none;
			}
		}
	}
</style>